import { useEffect, useRef } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';
import { keepsServiceScroll } from './scrollBehavior';

export default function ScrollToTop() {
    const { pathname, hash } = useLocation();
    const navType = useNavigationType();
    const previousPath = useRef(pathname);

    useEffect(() => {
        const fromPath = previousPath.current;
        previousPath.current = pathname;

        // POP = back/forward → let browser restore position
        if (navType === 'POP') return;

        // Hash link → scroll to anchor
        if (hash) {
            requestAnimationFrame(() => {
                const el = document.querySelector(hash);
                if (el) {
                    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
                    el.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth' });
                    if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '-1');
                    el.focus({ preventScroll: true });
                }
            });
            return;
        }

        // Opening or closing an inline service detail is not a page change.
        if (keepsServiceScroll(fromPath, pathname)) return;

        // PUSH/REPLACE → scroll to top after render
        requestAnimationFrame(() => {
            window.scrollTo(0, 0);
            document.querySelector('main')?.focus({ preventScroll: true });
        });
    }, [pathname, hash, navType]);

    return null;
}
